/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {ConfirmDialogComponent as ɵb} from './lib/components/dialogs/confirm-dialog/confirm-dialog.component';
export {NewRegistrationDialogComponent as ɵd} from './lib/components/dialogs/new-registration-dialog/new-registration-dialog.component';
export {SelectedFilesDialogComponent as ɵc} from './lib/components/dialogs/selected-files-dialog/selected-files-dialog.component';
export {NGX_FFM_TOKEN as ɵa} from './lib/ngx-ffm-config.token';